import {isEmpty} from 'lodash';
import {CHECKLISTS_WITH_ISSUES_FETCH, CHECKLISTS_WITH_ISSUES_FETCH_FULFILLED, CHECKLIST_FETCH} from '.';
import {getChecklistData} from '../../services/checklist-api';

export const fetchChecklistWithIssues = urns => (dispatch, getState) => {
  dispatch({type: CHECKLISTS_WITH_ISSUES_FETCH, payload: urns});
  if (!isEmpty(urns)) {
    getChecklistData({urns, dispatch, getState}).then(result => {
      dispatch({type: CHECKLIST_FETCH, payload: result});
      dispatch({type: CHECKLISTS_WITH_ISSUES_FETCH_FULFILLED, payload: urns});
    });
  }
};

export const fetchChecklistInstance = urn => (dispatch, getState) => {
  if (urn) {
    getChecklistData({urns: [urn], dispatch, getState}).then(result => {
      dispatch({type: CHECKLIST_FETCH, payload: result});
    });
  }
};
